import { ev } from "../util";

export enum DisplayForType {

    ALL_USERS = ev('ALL_USERS', 1),
    ONLY_AUTHORIZED_USERS = ev('ONLY_AUTHORIZED_USERS', 2),
    ONLY_AUTHORIZED_LIMITED_USERS = ev('ONLY_AUTHORIZED_LIMITED_USERS', 3),
    ONLY_AUTHORIZED_UNLIMITED_USERS = ev('ONLY_AUTHORIZED_UNLIMITED_USERS', 4),
    ONLY_UNAUTHORIZED_USERS = ev('ONLY_UNAUTHORIZED_USERS', 5)
}
